// Quiz scoring
import { QUESTIONS_TYPE } from '../constants/default/quiz';
import type { QuizCollectionModel } from '@/common/models/quiz.model';

// percentStep = 100 / steps count
const percentStep = 100 / 4;

export const quiz: QuizCollectionModel = {
  q2: {
    id: 'q2',
    progress: percentStep / 7.5 * 2.5,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q2_question' },
    prevLink: '/score',
    nextLink: '/quiz/q3/score-rate',
    leftRate: { key: 'scor_ok_q2_rate_low' },
    rightRate: { key: 'scor_ok_q2_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  q3: {
    id: 'q3',
    progress: percentStep / 7.5 * 3.5,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q3_question' },
    prevLink: '/quiz/q2/score-rate',
    nextLink: '/quiz/q4/question',
    leftRate: { key: 'scor_ok_q3_rate_low' },
    rightRate: { key: 'scor_ok_q3_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  q4: {
    id: 'q4',
    progress: percentStep / 7.5 * 4.5,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q4_question' },
    prevLink: '/quiz/q3/score-rate',
    nextLink: '/quiz/q5/score-rate',
    options: [
      { id: 0, text: { key: 'scor_ok_q4_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q4_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q4_answer_3' } },
      { id: 3, text: { key: 'scor_ok_q4_answer_4' } },
      { id: 4, text: { key: 'scor_ok_q4_answer_5' } },
    ],
  },
  q5: {
    id: 'q5',
    progress: percentStep / 7.5 * 5.5,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q5_question' },
    prevLink: '/quiz/q4/question',
    nextLink: '/quiz/q6/question',
    leftRate: { key: 'scor_ok_q5_rate_low' },
    rightRate: { key: 'scor_ok_q5_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  q6: {
    id: 'q6',
    progress: percentStep / 7.5 * 6.5,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q6_question' },
    prevLink: '/quiz/q5/score-rate',
    nextLink: '/quiz/i1/intermediate',
    options: [
      { id: 0, text: { key: 'scor_ok_q6_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q6_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q6_answer_3' } },
      { id: 3, text: { key: 'scor_ok_q6_answer_4' } },
    ],
  },
  q7: {
    id: 'q7',
    progress: percentStep + percentStep / 11 * 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q7_question' },
    prevLink: '/quiz/q6/question',
    nextLink: '/quiz/q8/question',
    options: [
      { id: 0, text: { key: 'scor_ok_q7_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q7_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q7_answer_3' } },
      { id: 3, text: { key: 'scor_ok_q7_answer_4' } },
      { id: 4, text: { key: 'scor_ok_q7_answer_5' } },
      { id: 5, text: { key: 'scor_ok_q7_answer_6' } },
    ],
  },
  q8: {
    id: 'q8',
    progress: percentStep + percentStep / 11 * 4,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q8_question' },
    prevLink: '/quiz/q7/question',
    nextLink: '/quiz/q9/score-rate',
    options: [
      { id: 0, text: { key: 'scor_ok_q8_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q8_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q8_answer_3' } },
      { id: 3, text: { key: 'scor_ok_q8_answer_4' } },
      { id: 4, text: { key: 'scor_ok_q8_answer_5' } },
    ],
  },
  q9: {
    id: 'q9',
    progress: percentStep + percentStep / 11 * 5,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q9_question' },
    prevLink: '/quiz/q8/question',
    nextLink: '/quiz/q10/score-rate',
    leftRate: { key: 'scor_ok_q9_rate_low' },
    rightRate: { key: 'scor_ok_q9_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
    getHints: (quizAnswers) => {
      if (quizAnswers.q9 === undefined) {
        return [];
      }
      if (quizAnswers.q9 <= 2) {
        return [{ id: 0, title: { key: 'scor_ok_q9_hint_1_title' } }];
      }
      return [];
    },
  },
  q10: {
    id: 'q10',
    progress: percentStep + percentStep / 11 * 6,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q10_question' },
    prevLink: '/quiz/q9/score-rate',
    nextLink: '/quiz/q11/question',
    leftRate: { key: 'scor_ok_q10_rate_low' },
    rightRate: { key: 'scor_ok_q10_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  q11: {
    id: 'q11',
    progress: percentStep + percentStep / 11 * 7,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q11_question' },
    prevLink: '/quiz/q10/score-rate',
    nextLink: '/quiz/q12/score-rate',
    options: [
      { id: 0, text: { key: 'scor_ok_q11_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q11_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q11_answer_3' } },
      { id: 3, text: { key: 'scor_ok_q11_answer_4' } },
    ],
  },
  q12: {
    id: 'q12',
    progress: percentStep + percentStep / 11 * 8,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q12_question' },
    prevLink: '/quiz/q11/question',
    nextLink: '/quiz/q13/score-rate',
    leftRate: { key: 'scor_ok_q12_rate_low' },
    rightRate: { key: 'scor_ok_q12_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  q13: {
    id: 'q13',
    progress: percentStep + percentStep / 11 * 9,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q13_question' },
    prevLink: '/quiz/q12/score-rate',
    nextLink: '/quiz/q14/question',
    leftRate: { key: 'scor_ok_q13_rate_low' },
    rightRate: { key: 'scor_ok_q13_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  q14: {
    id: 'q14',
    progress: percentStep + percentStep / 11 * 10,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q14_question' },
    prevLink: '/quiz/q13/score-rate',
    nextLink: '/quiz/i2/intermediate',
    options: [
      { id: 0, text: { key: 'scor_ok_q14_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q14_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q14_answer_3' } },
    ],
  },
  q15: {
    id: 'q15',
    progress: percentStep * 2 + percentStep / 11 * 2,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q15_question' },
    prevLink: '/quiz/q14/question',
    nextLink: '/quiz/q16/question',
    options: [
      { id: 0, text: { key: 'scor_ok_q15_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q15_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q15_answer_3' } },
      { id: 3, text: { key: 'scor_ok_q15_answer_4' } },
    ],
  },
  q16: {
    id: 'q16',
    progress: percentStep * 2 + percentStep / 11 * 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q16_question' },
    prevLink: '/quiz/q15/question',
    nextLink: '/quiz/q17/question',
    options: [
      { id: 0, text: { key: 'scor_ok_q16_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q16_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q16_answer_3' } },
      { id: 3, text: { key: 'scor_ok_q16_answer_4' } },
    ],
    getHints: (quizAnswers) => {
      if (quizAnswers.q15 === undefined || quizAnswers.q16 === undefined) {
        return [];
      }
      if (quizAnswers.q15 < quizAnswers.q16) {
        return [{ id: 0, title: { key: 'scor_ok_q16_hint_1_title' } }];
      }
      return [];
    },
  },
  q17: {
    id: 'q17',
    progress: percentStep * 2 + percentStep / 11 * 4,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q17_question' },
    prevLink: '/quiz/q16/question',
    nextLink: '/quiz/q18/score-rate',
    options: [
      { id: 0, text: { key: 'scor_ok_q17_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q17_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q17_answer_3' } },
      { id: 3, text: { key: 'scor_ok_q17_answer_4' } },
      { id: 4, text: { key: 'scor_ok_q17_answer_5' } },
    ],
    getHints: (quizAnswers) => {
      if (quizAnswers.q17 === undefined) {
        return [];
      }
      if (quizAnswers.q17 >= 1 && quizAnswers.q17 <= 4) {
        return [{ id: 0, title: { key: 'scor_ok_q17_hint_1_title' } }];
      }
      return [];
    },
  },
  q18: {
    id: 'q18',
    progress: percentStep * 2 + percentStep / 11 * 5,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q18_question' },
    prevLink: '/quiz/q17/question',
    nextLink: '/quiz/q19/score-rate',
    leftRate: { key: 'scor_ok_q18_rate_low' },
    rightRate: { key: 'scor_ok_q18_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  q19: {
    id: 'q19',
    progress: percentStep * 2 + percentStep / 11 * 6,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q19_question' },
    prevLink: '/quiz/q18/score-rate',
    nextLink: '/quiz/q20/score-rate',
    leftRate: { key: 'scor_ok_q19_rate_low' },
    rightRate: { key: 'scor_ok_q19_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  q20: {
    id: 'q20',
    progress: percentStep * 2 + percentStep / 11 * 7,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q20_question' },
    prevLink: '/quiz/q19/score-rate',
    nextLink: '/quiz/q21/score-rate',
    leftRate: { key: 'scor_ok_q20_rate_low' },
    rightRate: { key: 'scor_ok_q20_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  q21: {
    id: 'q21',
    progress: percentStep * 2 + percentStep / 11 * 8,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q21_question' },
    prevLink: '/quiz/q20/score-rate',
    nextLink: '/quiz/q22/question',
    leftRate: { key: 'scor_ok_q21_rate_low' },
    rightRate: { key: 'scor_ok_q21_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  q22: {
    id: 'q22',
    progress: percentStep * 2 + percentStep / 11 * 9,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q22_question' },
    prevLink: '/quiz/q21/score-rate',
    nextLink: '/quiz/q23/question',
    options: [
      { id: 0, text: { key: 'scor_ok_q22_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q22_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q22_answer_3' } },
    ],
    getHints: (quizAnswers) => {
      if (quizAnswers.q22 === undefined) {
        return [];
      }
      return [{ id: 0, title: { key: 'scor_ok_q22_hint_1_title' }, subtitle: { key: 'scor_ok_q22_hint_1_subtitle' } }];
    },
  },
  q23: {
    id: 'q23',
    progress: percentStep * 2 + percentStep / 11 * 10,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q23_question' },
    prevLink: '/quiz/q22/question',
    nextLink: '/quiz/i3/intermediate',
    options: [
      { id: 0, text: { key: 'scor_ok_q23_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q23_answer_2' } },
    ],
  },
  q24: {
    id: 'q24',
    progress: percentStep * 3 + percentStep / 8.5 * 1.5,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q24_question' },
    prevLink: '/quiz/q23/question',
    nextLink: '/quiz/q25/question',
    options: [
      { id: 0, text: { key: 'scor_ok_q24_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q24_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q24_answer_3' } },
    ],
  },
  q25: {
    id: 'q25',
    progress: percentStep * 3 + percentStep / 8.5 * 2.5,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q25_question' },
    prevLink: '/quiz/q24/question',
    nextLink: '/quiz/q26/question',
    options: [
      { id: 0, text: { key: 'scor_ok_q25_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q25_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q25_answer_3' } },
    ],
    getHints: (quizAnswers) => {
      if (quizAnswers.q25 === undefined) {
        return [];
      }
      return [{ id: 0, title: { key: 'scor_ok_q25_hint_1_title' }, subtitle: { key: 'scor_ok_q25_hint_1_subtitle' } }];
    },
  },
  q26: {
    id: 'q26',
    progress: percentStep * 3 + percentStep / 8.5 * 3.5,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q26_question' },
    prevLink: '/quiz/q25/question',
    nextLink: '/quiz/q27/question',
    options: [
      { id: 0, text: { key: 'scor_ok_q26_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q26_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q26_answer_3' } },
      { id: 3, text: { key: 'scor_ok_q26_answer_4' } },
      { id: 4, text: { key: 'scor_ok_q26_answer_5' } },
    ],
    getHints: (quizAnswers) => {
      if (quizAnswers.q26 === undefined) {
        return [];
      }
      return [{ id: 0, title: { key: 'scor_ok_q26_hint_1_title' } }];
    },
  },
  q27: {
    id: 'q27',
    progress: percentStep * 3 + percentStep / 8.5 * 4.5,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'scor_ok_q27_question' },
    prevLink: '/quiz/q26/question',
    nextLink: '/quiz/q28/score-rate',
    options: [
      { id: 0, text: { key: 'scor_ok_q27_answer_1' } },
      { id: 1, text: { key: 'scor_ok_q27_answer_2' } },
      { id: 2, text: { key: 'scor_ok_q27_answer_3' } },
    ],
  },
  q28: {
    id: 'q28',
    progress: percentStep * 3 + percentStep / 8.5 * 5.5,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q28_question' },
    prevLink: '/quiz/q27/question',
    nextLink: '/quiz/q29/score-rate',
    leftRate: { key: 'scor_ok_q28_rate_low' },
    rightRate: { key: 'scor_ok_q28_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  q29: {
    id: 'q29',
    progress: percentStep * 3 + percentStep / 8.5 * 6.5,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q29_question' },
    prevLink: '/quiz/q28/score-rate',
    nextLink: '/quiz/q30/score-rate',
    leftRate: { key: 'scor_ok_q29_rate_low' },
    rightRate: { key: 'scor_ok_q29_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  q30: {
    id: 'q30',
    progress: percentStep * 3 + percentStep / 8.5 * 7.5,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q30_question' },
    prevLink: '/quiz/q29/score-rate',
    nextLink: '/quiz/q31/score-rate',
    leftRate: { key: 'scor_ok_q30_rate_low' },
    rightRate: { key: 'scor_ok_q30_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  q31: {
    id: 'q31',
    progress: percentStep * 3 + percentStep / 8.5 * 8.5,
    type: QUESTIONS_TYPE.SCORE_RATE,
    question: { key: 'scor_ok_q31_question' },
    prevLink: '/quiz/q30/score-rate',
    nextLink: '/quiz/score-onboarding',
    leftRate: { key: 'scor_ok_q31_rate_low' },
    rightRate: { key: 'scor_ok_q31_rate_high' },
    options: [
      { id: 0, text: { key: 'scor_rate_answer_1' } },
      { id: 1, text: { key: 'scor_rate_answer_2' } },
      { id: 2, text: { key: 'scor_rate_answer_3' } },
      { id: 3, text: { key: 'scor_rate_answer_4' } },
      { id: 4, text: { key: 'scor_rate_answer_5' } },
    ],
  },
  i1: {
    id: 'i1',
    progress: percentStep / 7.5 * 7.5,
    type: QUESTIONS_TYPE.INTERMEDIATE,
    prevLink: '/quiz/q6/question',
    nextLink: '/quiz/q7/question',
    intermediate: {
      title: { key: 'scor_ok_i1_title' },
      subtitle: { key: 'scor_ok_i1_subtitle' },
      images: [
        { src: '/images/en/EN_img_quiz3_i1_1.webp', width: 1125, height: 1031, class: 'full-width' },
      ],
    },
  },
  i2: {
    id: 'i2',
    progress: percentStep + percentStep / 11 * 11,
    type: QUESTIONS_TYPE.INTERMEDIATE,
    prevLink: '/quiz/q14/question',
    nextLink: '/quiz/q15/question',
    intermediate: {
      title: { key: 'scor_ok_i2_title' },
      images: [
        { src: '/images/en/EN_img_quiz3_i2_1.webp', width: 933, height: 930 },
        { src: '/images/en/EN_img_quiz3_i2_2.webp', width: 933, height: 930 },
        { src: '/images/en/EN_img_quiz3_i2_3.webp', width: 933, height: 930 },
      ],
    },
  },
  i3: {
    id: 'i3',
    progress: percentStep * 2 + percentStep / 11 * 11,
    type: QUESTIONS_TYPE.INTERMEDIATE,
    prevLink: '/quiz/q23/question',
    nextLink: '/quiz/q24/question',
    intermediate: {
      title: { key: 'scor_ok_i3_title' },
      images: [
        { src: '/images/en/EN_img_quiz3_i3_1.webp', width: 933, height: 879 },
        { src: '/images/en/EN_img_quiz3_i3_2.webp', width: 933, height: 879 },
        { src: '/images/en/EN_img_quiz3_i3_3.webp', width: 933, height: 879 },
      ],
    },
  },
};
